// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"290":"1538eb6e","447":"2fd62e13","580":"0c761056","905":"1538eb6e"}[chunkId] + ".chunk.css";
};